import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { SparkObjectDataset } from 'app/model/dataset/spark.dataset';
import { Metamodel } from 'app/model/base/model';
import { SparkLinkedService } from 'app/model/linkedservice/spark.linkedservice';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { format } from 'app/shared/utils/string.util';
import { GlobalVariables } from 'app/services/globals';
import { batchSizeV2Metadata, queryTimeoutV2Metadata } from '../consts/metadata-consts';

export const sparkObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(SparkObjectDataset).name,
    displayName: stringResources.Spark_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(SparkLinkedService).name],
    isSource: true,
    isSink: false,
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-spark',
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Spark_datastore'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.SByte),
    v1SupportSchema: true,
    category: ['Database'],
    copySourceControls: [
        GlobalVariables.enableSparkV2BatchSize
            ? {
                  ...batchSizeV2Metadata,
                  child: {
                      ...batchSizeV2Metadata.child,
                      description: format(
                          stringResources.BatchSize_Description_Template,
                          stringResources.Spark_DisplayText
                      )
                  },
                  hide: '{ owner && owner.sourceDataset && owner.sourceDataset.linkedService && owner.sourceDataset.linkedService.version !== "v2" }'
              }
            : undefined,
        GlobalVariables.enableSparkV2QueryTimeout
            ? {
                  ...queryTimeoutV2Metadata,
                  hide: '{ owner && owner.sourceDataset && owner.sourceDataset.linkedService && owner.sourceDataset.linkedService.version !== "v2" }'
              }
            : undefined
    ].filter(Boolean)
};
